import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd, { ConfigProvider } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './assets/styles/global.css'
import './assets/styles/mobile.css'

import App from './App.vue'
import router from './router'
import { useUserStore } from './store/user'

// 定义大尺寸主题配置
const bigTheme = {
  token: {
    // 基础字体大小从14px增加到16px
    fontSize: 16,
    // 基础控件高度从32px增加到40px
    controlHeight: 40,
    // 圆角大小从6px增加到8px
    borderRadius: 8,
    // 内边距相关
    padding: 20,
    paddingLG: 28,
    paddingSM: 16,
    paddingXS: 12,
    paddingXXS: 8,
    // 外边距相关
    margin: 20,
    marginLG: 28,
    marginSM: 16,
    marginXS: 12,
    marginXXS: 8,
    // 尺寸相关
    size: 20,
    sizeLG: 28,
    sizeSM: 16,
    sizeXS: 12,
    // 字体大小梯度
    fontSizeLG: 18,
    fontSizeSM: 14,
    fontSizeXL: 22,
    // 行高
    lineHeight: 1.6,
    // 控件相关
    controlHeightLG: 48,
    controlHeightSM: 32,
    controlPaddingHorizontal: 16,
    controlPaddingHorizontalSM: 12,
  }
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(Antd)

// 全局配置大尺寸主题
app.provide('antdTheme', bigTheme)

// 初始化用户状态
const userStore = useUserStore()
userStore.initializeAuth()

app.mount('#app')